const investigationNameSimplifier=

// maps extended names in investigation list to simpler for to avoid duplication in investigationExtraQuestions
{
 "Bone XR (urgent)": "Bone XR",
 "CT brain (if MRI contraindicated)": "CT brain",
 "Urgent Upper GI Endoscopy": "Upper GI Endoscopy",
"Routine Upper GI Endoscopy": "Upper GI Endoscopy"
}

export default investigationNameSimplifier